import { useMemo, useState } from "react";
import { motion } from "framer-motion";
import Lightbox from "@/components/Lightbox";
import { PORTFOLIO, PORTFOLIO_FILTERS } from "@/data/site";
import { PORTFOLIO as TID } from "@/constants/testIds";

const MasonryGallery = ({ filterable = true, initialTag = "all", limit = null }) => {
  const [active, setActive] = useState(initialTag);
  const [lightboxIndex, setLightboxIndex] = useState(null);

  const items = useMemo(() => {
    const filtered =
      active === "all" ? PORTFOLIO : PORTFOLIO.filter((p) => p.tags.includes(active));
    return limit ? filtered.slice(0, limit) : filtered;
  }, [active, limit]);

  const openAt = (i) => setLightboxIndex(i);
  const close = () => setLightboxIndex(null);
  const prev = () => setLightboxIndex((i) => (i - 1 + items.length) % items.length);
  const next = () => setLightboxIndex((i) => (i + 1) % items.length);

  return (
    <section className="bg-white py-12 md:py-16">
      <div className="container-x">
        {filterable && (
          <div className="flex flex-wrap gap-2 md:gap-3 justify-center mb-12">
            {PORTFOLIO_FILTERS.map((f) => (
              <button
                key={f.id}
                data-testid={`${TID.filterBtn}-${f.id}`}
                onClick={() => setActive(f.id)}
                className={`px-4 py-2 text-[11px] uppercase tracking-[0.25em] border transition-colors ${
                  active === f.id
                    ? "bg-ink text-white border-ink"
                    : "border-neutral-300 text-neutral-600 hover:border-gold hover:text-gold"
                }`}
              >
                {f.label}
              </button>
            ))}
          </div>
        )}

        <div className="masonry-grid no-download" onContextMenu={(e) => e.preventDefault()}>
          {items.map((item, i) => (
            <motion.figure
              key={`${item.src}-${i}`}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.6 }}
              className="masonry-item overflow-hidden group cursor-zoom-in"
              onClick={() => openAt(i)}
              data-testid={`${TID.galleryItem}-${i}`}
            >
              <img
                src={item.src}
                alt="Portfolio"
                loading="lazy"
                draggable={false}
                className="w-full h-auto block transition-transform duration-[1200ms] ease-out group-hover:scale-105"
              />
            </motion.figure>
          ))}
        </div>

        {items.length === 0 && (
          <p className="text-center text-neutral-500 py-24">Nog geen foto's in deze categorie.</p>
        )}
      </div>

      {lightboxIndex !== null && (
        <Lightbox items={items} index={lightboxIndex} onClose={close} onPrev={prev} onNext={next} />
      )}
    </section>
  );
};

export default MasonryGallery;
